"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageModal = MessageModal;
const window_1 = require("../../contexts/window");
const react_1 = __importStar(require("react"));
const controls_1 = require("../controls");
const modal_types_1 = require("./modal-types");
const constants_1 = require("../../modals/constants");
const modal_base_1 = require("./modal-base");
const DEFAULT_AUTOCLOSE_TIME = 2500;
const getTimer = (autoClose) => {
    if (!autoClose) {
        return 0;
    }
    switch (typeof autoClose) {
        case 'number':
            return autoClose;
        case 'boolean':
            return DEFAULT_AUTOCLOSE_TIME;
        case 'string':
            return autoClose === 'true' ? DEFAULT_AUTOCLOSE_TIME : 0;
    }
};
function MessageModal({ type, title, text, close, closeText, autoClose, buttonClassName }) {
    const messageType = modal_types_1.messageTypes[type] || modal_types_1.messageTypes.information;
    const { isMobile } = (0, window_1.useWindow)();
    const widthStyles = isMobile ? { maxWidth: '480px' } : { maxWidth: '500px' };
    const styles = Object.assign(Object.assign({}, constants_1.messageStyles), widthStyles);
    const buttonClassNames = `btn btn-${buttonClassName || 'secondary'}`;
    (0, react_1.useEffect)(() => {
        let timer = getTimer(autoClose);
        if (timer > 0) {
            setTimeout(close, timer);
        }
    });
    return (react_1.default.createElement(modal_base_1.ModalBase, { messageType: messageType, text: text, dialogStyles: styles, close: close, title: title, showFooter: !!closeText },
        react_1.default.createElement(controls_1.Button, { id: 'confirmation-secondary', classes: buttonClassNames, text: closeText, onClick: close, disabled: false })));
}
;
